/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_FactsInputs */

const en_case_detail_facts = /** @type {(inputs: Case_Detail_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facts`)
};

const pt_br2_case_detail_facts = /** @type {(inputs: Case_Detail_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados do caso`)
};

/**
* | output |
* | --- |
* | "Facts" |
*
* @param {Case_Detail_FactsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_facts = /** @type {((inputs?: Case_Detail_FactsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_FactsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_facts(inputs)
	return pt_br2_case_detail_facts(inputs)
});